export const getters = {
    isAuthenticate(state) {
        return state.isAuthenticate
    },
    currentCustomer(state) {
        return state.customer;
    }
}
